import { AxiosResponse } from 'axios';

import axiosInstance from 'api/base';
import { normalizePageData } from 'utils/commonNormalizer';
import { normalizeSearchFiltersPayload } from 'utils/filters';
import { prepareFormData } from 'utils/form';
import { IAllPageFilters, IPageType } from 'utils/types';

import { normalizeCountryGroup } from './normalizers';
import {
  ICountryGroup,
  ICountryGroupData,
  ICountryGroupForm,
  IUpdateCountryGroup,
} from './types';

const ICountryGroupsApi = {
  async getAllCountryGroups(
    filters: IAllPageFilters,
  ): Promise<IPageType<ICountryGroupData>> {
    const normalizedFilter = normalizeSearchFiltersPayload(filters);

    const response = await axiosInstance.get('country-groups', {
      params: normalizedFilter,
    });

    return normalizePageData<ICountryGroup, ICountryGroupData>(
      response.data,
      normalizeCountryGroup,
      JSON.stringify(filters.search),
    );
  },

  async createCountryGroup(payload: ICountryGroupForm): Promise<AxiosResponse> {
    const normalizedPayload = prepareFormData(payload);

    const response = await axiosInstance.post(`country-groups`, normalizedPayload);
    return response;
  },

  async getCountryGroup(id: string): Promise<ICountryGroupData> {
    const response = await axiosInstance.get(`country-groups/${id}`);

    return normalizeCountryGroup(response.data);
  },

  async updateCountryGroup({ id, payload }: IUpdateCountryGroup): Promise<AxiosResponse> {
    const normalizedPayload = prepareFormData(payload);

    const response = await axiosInstance.put(`country-groups/${id}`, normalizedPayload);
    return response;
  },

  async deleteCountryGroup(id: number): Promise<AxiosResponse> {
    const result = await axiosInstance.delete(`country-groups/${id}`);

    return result;
  },
};

export default ICountryGroupsApi;
